module.exports = __webpack_public_path__ + "img/2.91c38dd8.png";